import PatternMatcher from "./PatternMatcher";

export default PatternMatcher;

export { PatternMatcher };
